import React from 'react';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { makeSelectShowHomepagePro } from 'containers/Main/selectors';
import HomePage from 'containers/HomePage';
import HomePagePro from 'containers/HomePagePro';

function HomePageWrapper() {
  const showHomepagePro = useSelector(makeSelectShowHomepagePro());
  const location = useLocation();
  const params = qs.parse(location.search.slice(1));

  if (params.showcorp === '1' || showHomepagePro) return <HomePagePro />;

  return <HomePage />;
}

export default HomePageWrapper;
